export default __webpack_public_path__ + "static/media/minivistaw-flotautobuses.c4b74234.jpg";